export const START_FETCH_SCHEDULE = 'START_FETCH_SCHEDULE'
export const FAILED_FETCH_SCHEDULE = 'FAILED_FETCH_SCHEDULE'
export const SUCCESS_FETCH_SCHEDULE = 'SUCCESS_FETCH_SCHEDULE'
export const SET_LOGGEDIN_TEACHER_ID = 'SET_LOGGEDIN_TEACHER_ID'

export const SET_FILTER_DATA = 'SET_FILTER_DATA';

import getTimetable from 'controllers/school/getTimetable'

export function fetchSchedule(schoolId, fetchOption) {

  return function(dispatch) {

    dispatch({
      type: START_FETCH_SCHEDULE,
    })

    getTimetable(schoolId, fetchOption)
      .then(({ data }) => {

        dispatch({
          type: SUCCESS_FETCH_SCHEDULE,
          events: data.result_list,
        })

    })
    .catch((error)  => {
      dispatch({
        type: FAILED_FETCH_SCHEDULE,
        error,
      })
    })

  }

}

export function setFilterData(filterData) {
  return {
    type: SET_FILTER_DATA,
    filterData,
  }
}

const initState = {
  events: [],
  filterData: {},
}

export default function(state = initState, action){
  switch(action.type){

    case START_FETCH_SCHEDULE: {
      return {
        ...state,
        fetching: true,
      }
    }
    case SUCCESS_FETCH_SCHEDULE: {
      return {
        ...state,
        events: action.events,
        fetching: false,
      }
    }
    case FAILED_FETCH_SCHEDULE: {
      return {
        ...state,
        error: action.error,
        fetching: false,
      }
    }

    case SET_FILTER_DATA: {
      return {
        ...state,
        filterData: action.filterData,
      }
    }

    case SET_LOGGEDIN_TEACHER_ID: {
      return {
        ...state,
        loggedinTeacherId: action.loggedinTeacherId,
      }
    }

    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Schedule/ducks.js